/**
 * StatsCard Component
 * 통계 카드 - 완료/거절 건수, 수락률 표시
 */
import React from 'react';
import styles from '../../styles/shared/StatsCard.module.css';

interface StatsCardProps {
    completedCount: number;
    rejectedCount: number;
    acceptanceRate: number;
}

export const StatsCard: React.FC<StatsCardProps> = ({
    completedCount,
    rejectedCount,
    acceptanceRate
}) => {
    return (
        <div className={styles['stats-card']}>
            <div className={styles['stats-grid']}>
                <div className={styles['stat-item']}>
                    <div className={styles['stat-label']}>완료 건수</div>
                    <div className={styles['stat-value']}>{completedCount}건</div>
                </div>
                <div className={styles['stat-item']}>
                    <div className={styles['stat-label']}>거절 건수</div>
                    <div className={styles['stat-value']}>{rejectedCount}건</div>
                </div>
                <div className={styles['stat-item']}>
                    <div className={styles['stat-label']}>수락률</div>
                    <div className={styles['stat-value']}>{acceptanceRate}%</div>
                </div>
            </div>
        </div>
    );
};
